import { Inject, Injectable } from '@angular/core';
import { EMPLOYEE_PROPERTIES_BITMASK_SERVICE, EmployeePropertiesBitmaskService } from './upgrade/employee-properties-bitmask.service';
import { Observable } from 'rxjs/observable';
import { Subject } from 'rxjs/subject';
import { Employee } from 'resteasytox';
import { WrapperService } from '../api/wrapper.service';
import { USER_SERVICE } from './upgrade/user.service';
import { User } from '../api/model/user';

@Injectable()
export class UserService {

	private _user: Employee;

	constructor(@Inject(EMPLOYEE_PROPERTIES_BITMASK_SERVICE) private employeePropertiesBitmaskService: EmployeePropertiesBitmaskService,
		@Inject(USER_SERVICE) private userServiceNg1: any) {

		this._user = userServiceNg1.getUser();
	}

	get user(): Employee {
		return this._user;
		// return this.rootScopeService.user === this._user
		// 	? this._user
		// 	: this._user = this.rootScopeService.user;
	}

	set user(user: Employee) {
		this._user = user;
	}


	checkUserSetting(property: string, _user?: Employee): boolean {
		const user: Employee = _user || this.user;
		if (user) {
			return this.employeePropertiesBitmaskService.hasProperty(property, user.settingsBitmask);
		}
	}

	public isAdmin(): boolean {
		return this.user.admin;
	}

	// initUser(): Observable<any> {
	// 	console.log('init user');
	// 	return this.wrapperService.wrapGetRequest('https://ttqa.rqp.co/settings/user/current', 'initUser')
	// 		.map((user: Employee) => {
	// 			console.log('user inited');
	// 			this.user = user;
	// 		});
	// }

}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts